import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { FaStar } from "react-icons/fa";
import Rating from '../common/Rating';

const SingleStore = ({createPopUp,flyToStore,storeData,REF}) => {
  const handleGoToLocation = ()=>{
    flyToStore(storeData);
    createPopUp(storeData);
  }


  const altImag = `https://th.bing.com/th/id/OIP.vg49Rg4lf-bVtcQjHxlJkgHaHa?rs=1&pid=ImgDetMain`
  return (
    <div  ref={REF} onMouseOver={handleGoToLocation} className="card rounded overflow-hidden shadow-lg m-5 cursor-pointer">
            <Link  to={`/?path=description&ID=${storeData.id}&type=store`}>
              <div className="h-[200px] skeleton">
                <img
                  className="nativeImg object-cover w-full h-[200px]"
                  src={storeData?.images && storeData?.images.length>0?storeData?.images[0]?.image:altImag}
                  alt={storeData.name}
                />
              </div>
              <div className="py-3 text-sm space-y-1 px-4">
                <div className="">
                  <p className="text-2xl truncate font-medium ">{storeData.name}</p>
                </div>
               <div className="mt-2 flex">
                {/* <div className="">
                <p className="text-lg truncate text-gray-400 mr-2">{storeData.category}</p>
                </div> */}
                {/* <span className="text-lg truncate text-gray-400 mr-2">&bull;</span> */}
            {
              storeData.category =="Restaurant" && <> <div className="">
              <p className="text-lg truncate text-gray-400 mr-2">$$</p>
              </div>
               <span className="text-lg truncate text-gray-400 mr-2">&bull;</span>
               </>
            } 
                <div className="mr-2 flex">
              {
                storeData.rating &&  <span className="text-lg truncate text-gray-400 mr-2">{storeData.rating} </span>
              }
                <div className="mr-2 flex items-center">
              {
               storeData?.rating &&   <Rating rating={storeData?.rating} />
              }
                </div>
                {
                 storeData?.reviews_count && <span className="text-lg truncate text-gray-400 mr-2">({storeData?.reviews_count})</span>
                }
                </div>
               </div>
               {
                storeData.type === "PLACE" &&  <p className="text-lg truncate text-gray-400 mr-2"><span className={`text-lg truncate text-${storeData?.open_now?"green":"red"}-600 mr-2`}>{storeData?.open_now?"Open":"Closed"}</span></p>

               }
                <p className="text-lg text-gray-400 mr-2">{storeData.description}</p>
              </div>
            </Link>
          </div>
  )
}

export default SingleStore
